<template>
  <div class="export-lower-container">
    <el-dialog
      width="450px"
      :title="$t('createQuotation.quotationPromptInformation')"
      :visible.sync="dialogFormVisible"
    >
      <p
        class="out-of-stock"
        v-if="shareMessageDto.lowerShelf !=null && shareMessageDto.lowerShelf !=''"
      >
        {{ $t('homePage.productsPulledQuotation') }}
        {{ shareMessageDto.lowerShelf }}
      </p>
      <p
        class="out-of-stock"
        v-if="shareMessageDto.spdcProduct !=null &&
          shareMessageDto.spdcProduct !='' ||
          shareMessageDto.orderInfo !=null &&
          shareMessageDto.orderInfo !=''"
      >
        <!--您的报价单中有服务商专供产品：-->
        {{ $t('homePage.serviceProvidersQuotation') }}
        {{ shareMessageDto.spdcProduct }}
        <span
          v-if="shareMessageDto.orderInfo !=null && shareMessageDto.orderInfo !=''"
        >
          {{ shareMessageDto.orderInfo }}
        </span>
      </p>
      <div
        style="text-align: left;color:red"
        v-if="shareMessageDto.supplyInfo !=null &&
          shareMessageDto.supplyInfo.length>0"
      >
        <!--您的报价单中有供应紧缺的产品：-->
        {{ $t('homePage.shortagesProductsQuotation') }}
        <table style="text-align: left;">
          <tr v-for="(item,j) in shareMessageDto.supplyInfo" :key="j">
            <td style="color:black">
              {{ item }}
            </td>
          </tr>
        </table>
      </div>
      <div style="padding-bottom: 10px">
        <div style="text-align: left">
          <span
            style="text-align: left;color:red;"
            v-if="shareMessageDto.supplyList !=null &&
              shareMessageDto.supplyList.length>0"
          >
            <!--您的报价单中有供应紧缺的产品-->
            {{ $t('homePage.shortagesProductsQuotation') }}
          </span>
          <span
            style="text-align: left;color:red;"
            v-if="shareMessageDto.deliveryPeriod !=null &&
              shareMessageDto.deliveryPeriod !=''"
          >
            ,
          </span>
          <span
            style="text-align: left;color:red;"
            v-if="shareMessageDto.deliveryPeriod !=null &&
              shareMessageDto.deliveryPeriod !=''"
          >
            <!--当前项目备货周期为-->
            {{ $t('homePage.currentProjectCycle') }}
            {{ shareMessageDto.deliveryPeriod }}
            <!--天，请提前在CRM系统上勾选备货。-->
            {{ $t('homePage.DaysCRMSystem') }}
          </span>
        </div>
      </div>
      <div
        style="text-align: left;color:red"
        v-if="shareMessageDto.promptInformation !=null &&
          shareMessageDto.promptInformation !=''"
      >
        {{ shareMessageDto.promptInformation }}
      </div>
      <div style="text-align: left;color:red" v-if="shareMessageDto.matchingFlg">
        <!--如若项目极简光交换机部署在弱电箱场景，必须采购后面详情指定弱电箱，请点击查看-->
        {{ $t('homePage.straussClickViewDetails') }}
        <el-button
          type="primary"
          @click="openWeakCurrentBoxScene"
        >
          <!--详情-->
          {{ $t('homePage.details') }}
        </el-button>
      </div>
      <div
        class="myBlackColor"
        style="text-align: left;color:red; margin-bottom: 20px"
        v-if="shareMessageDto.supplyList !=null &&
          shareMessageDto.supplyList.length>0"
      >
        <el-table
          :data="shareMessageDto.supplyList"
          border
          style="width: 100%;color: black"
        >
          <el-table-column
            prop="productName"
            :label="$t('homePage.productModel')"
            width="240"
          />
          <el-table-column
            prop="expectedMitigationDate"
            :label="$t('homePage.expectedEaseDate')"
            width="120"
          />
          <el-table-column
            prop="deliveryPeriod"
            :label="$t('homePage.stockCycle')"
            width="100"
          />
          <el-table-column
            prop="supplyRemarks"
            :label="$t('homePage.remarks')"
          />
        </el-table>
      </div>
      <div
        class="myBlackColor"
        style="text-align: left;color:red;margin-bottom: 20px"
        v-if="shareMessageDto.delistingProductList !=null &&
          shareMessageDto.delistingProductList.length>0"
      >
        <div style="margin-bottom: 10px">
          {{ $t('createQuotation.quotationDeliStingProducts') }}
        </div>
      
        <el-table
          :data="shareMessageDto.delistingProductList"
          border
          style="width: 100%;color: black"
        >
          <el-table-column
            prop="productName"
            :label="$t('homePage.productModel')"
            width="240"
          />
          <el-table-column
            prop="statusDes"
            :label="$t('homePage.status')"
          />
        </el-table>
      </div>
      <div slot="footer" class="dialog-footer">
        <el-button @click="cancelWind">{{ $t('homePage.takeAway') }}</el-button>
        <el-button type="primary" @click="operateParent">{{ buttonName }}</el-button>
      </div>
    </el-dialog>
    <WeakCurrentBoxScene ref="weakCurrentBoxScene" />
  </div>
</template>

<script>
import { ProductItem } from '@/utils/numberFormater';
import WeakCurrentBoxScene from './WeakCurrentBoxScene';
export default {
  components: { WeakCurrentBoxScene },
  name: 'LowerShelf',
  mixins: [ProductItem],
  data () {
    return {
      // dialogFormVisible: false,
    };
  },
  props: {
    projectId: {
      type: String,
      default: ''
    },
    buttonName: {
      type: String,
      default: ''
    }
  },
  methods: {
    shareProject (projectId) {
      this.getLowershelf(this.projectId);
      // this.dialogFormVisible = true;
    },

    cancelWind () {
      this.lowershelf = '';
      this.dialogFormVisible = false;
    },
    openWeakCurrentBoxScene () {
      this.$refs.weakCurrentBoxScene.openWeakCurrentBoxScene();
    }

  }
};
</script>

<style lang="scss" scoped>
.export-lower-container{
  .el-dialog__header{
    text-align: left;
  }
.el-dialog__footer{
  text-align: right;
}
}
.out-of-stock{
  padding: 10px 10px;
  color: #dd0000;
  font-size: 14px;
  border: 1px solid red;
  text-align: left;
  margin-bottom: 20px;
  margin-left: 50px;
  margin-right: 50px;
}
</style>
